import {
    Box,
    Grid,
    GridItem,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Text,
    Link,
} from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';
import type { SubscriptionInfo, HeaderInfo, DetailsInfo } from './TableSectionWithNav';
import { StyledBox } from './styles';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import StyledButton from '../../components/Button/Button';
import DOMPurify from 'dompurify';

interface Props {
    valuesName: { [key: string]: string };
    mainCategories: { [key: string]: string };
    tableSection: SubscriptionInfo[];
    columns: Number;
    isOpenAll?: Boolean;
    isBlocked?: Boolean;
    headerValues: HeaderInfo[];
}

export const TableSectionDesktopWithNav = ({
    tableSection,
    mainCategories,
    valuesName,
    columns,
    isOpenAll,
    isBlocked,
    headerValues,
}: Props) => {
    const firstAccordionButtonRef = React.useRef<HTMLButtonElement>(null);
    const allowMultiple = isOpenAll ? true : undefined;

    const TableSectionContent = (section: SubscriptionInfo) => {
        return (
            <Grid
                gridTemplateColumns={{
                    base: '0.5fr 1fr',
                    // lg: `180px repeat(var(--table-cols, ${columns}), minmax(100px, 1fr))`,
                    lg: `214px repeat(var(--table-cols, ${columns}), minmax(100px, 1fr))`,
                }}
            >
                <Box
                    //p={{ base: 4, lg: 5 }}
                    padding={'30px 15px'}
                    h={'100%'}
                    display={'flex'}
                    alignItems={{ base: 'flex-start' }}
                    justifyContent={{ base: 'flex-start', lg: 'center' }}
                    color={'#171717'}
                    fontSize={'xs'}
                    fontWeight={'normal'}
                    lineHeight={'150%'}
                    borderBottom={{ lg: 'none' }}
                    flexDirection={{ lg: 'column' }}
                    borderRight={"1px solid #eee"}
                >
                    {section.name}
                </Box>

                {Object.keys(section.values).map((keyName, i) => (
                    <StyledBox
                        padding={'30px 15px'}
                        h="100%"
                        display={'flex'}
                        alignItems={{ base: 'flex-start', lg: 'center' }}
                        justifyContent={{ base: 'flex-start', lg: 'center' }}
                        color={'#171717'}
                        fontSize={'xs'}
                        fontWeight={'normal'}
                        lineHeight={'150%'}
                        // dangerouslySetInnerHTML={{ __html: section.values[keyName] }}
                    >
                        {section.values[keyName]}
                    </StyledBox>
                ))}
            </Grid>
        );
    };

    return (
        <Box>
            <Grid
                gridTemplateColumns={{
                    base: '0.5fr 1fr',
                    // lg: `180px repeat(var(--table-cols,  ${columns}), minmax(100px, 1fr))`,
                    lg: `214px repeat(var(--table-cols,  ${columns}), minmax(100px, 1fr))`,
                }}
                textAlign={'center'}
                color={'#1aac7a'}
                fontSize={'21px'}
                fontWeight={'600'}
                textTransform={'capitalize'}
                position={isBlocked ? 'relative' : 'sticky'}
                top={isBlocked ? '0' : '80px'}
                //background={'white'}
                background={"#fff"}
                zIndex={'5'}
                // borderBottom={'1px solid #eee'}
            >
                <Box
                    p={{ base: 4, lg: 5 }}
                    h={'100%'}
                    display={'flex'}
                    alignItems={{ base: 'flex-start', lg: 'center' }}
                    justifyContent={{ base: 'flex-start', lg: 'center' }}
                    color={'#171717'}
                    fontSize={'xs'}
                    fontWeight={'normal'}
                    lineHeight={'150%'}
                    borderBottom={{ lg: 'none' }}
                    flexDirection={{ lg: 'column' }}
                    borderRight={"1px solid #eee"}
                ></Box>
                {Object.keys(valuesName).map((keyName, i) => (
                    <StyledBox
                        padding={'10px 15px'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        {valuesName[keyName]}
                    </StyledBox>
                ))}
            </Grid>

            <Grid
                gridTemplateColumns={{
                    base: '0.5fr 1fr',
                    // lg: `180px repeat(var(--table-cols,  ${columns}), minmax(100px, 1fr))`,
                    lg: `214px repeat(var(--table-cols,  ${columns}), minmax(100px, 1fr))`,
                }}
                background={'white'}
                borderBottom={'1px solid #eee'}
            >
                <Box
                    p={{ base: 4, lg: 5 }}
                    h={'100%'}
                    display={'flex'}
                    alignItems={{ base: 'flex-start', lg: 'center' }}
                    justifyContent={{ base: 'flex-start', lg: 'center' }}
                    color={'#171717'}
                    fontSize={'xs'}
                    fontWeight={'normal'}
                    lineHeight={'150%'}
                    borderBottom={{ lg: 'none' }}
                    flexDirection={{ lg: 'column' }}
                    borderRight={"1px solid #eee"}
                ></Box>
                {headerValues.map((headerValue: HeaderInfo) => (
                    <StyledBox
                        padding={'10px 15px'}
                        display={'flex'}
                        flexDirection={'column'}
                        justifyContent={'space-between'}
                    >
                        <Text
                            fontWeight={'700'}
                            fontSize={'12px'}
                            lineHeight={'1.6'}
                            marginBottom={'13px'}
                        >
                            {headerValue.title}
                        </Text>
                        <Box>
                            {headerValue.priceTop && (
                                <Text
                                    fontWeight={'600'}
                                    fontSize={'18px'}
                                    lineHeight={'normal'}
                                    color={headerValue.priceColor ?? 'inherit'}
                                >
                                    {headerValue.priceTop}
                                </Text>
                            )}
                            <Text
                                fontWeight={'600'}
                                fontSize={'34px'}
                                lineHeight={'34px'}
                                color={headerValue.priceColor ?? 'inherit'}
                            >
                                {headerValue.price}
                            </Text>
                            {headerValue.crossedPrice && (
                                <Text
                                    fontSize={'16px'}
                                    lineHeight={'1'}
                                    textDecoration={'line-through'}
                                    margin={'3px 0 0'}
                                >
                                    {headerValue.crossedPrice}
                                </Text>
                            )}
                            <Text
                                fontSize={'12px'}
                                color={'#515151'}
                                lineHeight={'1.6'}
                                margin={'5px 0 15px'}
                            >
                                {headerValue.priceInfo}
                            </Text>

                            <Link
                                display={'inline-flex'}
                                alignItems={'center'}
                                fontWeight={'700'}
                                marginBottom={'15px'}
                                transition={'.2s'}
                                _hover={{
                                    color: '#DD1C4A',
                                    svg: {
                                        fill: '#DD1C4A',
                                    },
                                }}
                                href={headerValue.href}
                            >
                                <Text as={'span'} paddingRight={'10px'} fontSize={'14px'}>
                                    {headerValue.linkName}
                                </Text>
                                <svg
                                    width="7"
                                    height="10"
                                    viewBox="0 0 9 14"
                                    fill="#171717"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                </svg>
                            </Link>
                        </Box>
                    </StyledBox>
                ))}
            </Grid>

            <Accordion
                allowToggle
                //onChange={handleAccordionChange}
                allowMultiple={allowMultiple}
            >
                {Object.keys(mainCategories).map((mainCat, i) => (
                    <AccordionItem
                        key={'accordion-item-' + i}
                        borderBottom={"none"}
                        //borderBottom={'none'}
                        //ref={el => (accordionItemRefs.current[i] = el)}
                        // ref={i === 0 ? firstAccordionRef : undefined}
                    >
                        <AccordionButton
                            padding={'10px 15px'}
                            background={'#eeeeee'}
                            color={'#171717'}
                            fontSize={'18px'}
                            fontWeight={'600'}
                            justifyContent={'space-between'}
                            ref={i === 0 ? firstAccordionButtonRef : undefined}
                        >
                            {mainCategories[mainCat]}
                            {tableSection.map(section => {
                                if (
                                    section.category === mainCategories[mainCat] &&
                                    section?.subtitle
                                ) {
                                    return (
                                        <Text
                                            marginRight={'auto'}
                                            fontSize={'12px'}
                                            fontWeight={'400'}
                                            paddingLeft={'10px'}
                                            paddingTop={'4px'}
                                            // alignSelf={'baseline'}
                                        >
                                            {section.subtitle}
                                        </Text>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                            <AccordionIcon />
                        </AccordionButton>
                        {tableSection.map(section => {
                            if (section.category === mainCategories[mainCat]) {
                                return (
                                    <Box background={section.isGray ? '#EEE' : ''} p={0}>
                                        {TableSectionContent(section)}
                                    </Box>
                                );
                            } else {
                                return null;
                            }
                        })}
                        {tableSection.map(section => {
                            if (section.category === mainCategories[mainCat] && section.details) {
                                //console.log(section.details);
                                return (
                                    <AccordionPanel background={section.isGray ? '#EEE' : ''} p={0}>
                                        {section.details.map((detail: DetailsInfo) => {
                                            return (
                                                <Grid
                                                    gridTemplateColumns={{
                                                        base: '0.5fr 1fr',
                                                        // lg: `180px repeat(var(--table-cols, ${columns}), minmax(100px, 1fr))`,
                                                        lg: `214px repeat(var(--table-cols, ${columns}), minmax(100px, 1fr))`,
                                                    }}
                                                >
                                                    <Box
                                                       padding={'30px 15px'}
                                                        h={'100%'}
                                                        display={'block'}
                                                        alignItems={{ base: 'flex-start' }}
                                                        justifyContent={{
                                                            base: 'flex-start',
                                                            lg: 'center',
                                                        }}
                                                        paddingRight={'10px !important'}
                                                        borderRight={'1px solid #eee'}
                                                        color={'#171717'}
                                                        fontSize={'xs'}
                                                        fontWeight={'normal'}
                                                        lineHeight={'150%'}
                                                        borderBottom={{ lg: 'none' }}
                                                        flexDirection={{ lg: 'column' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: DOMPurify.sanitize(detail.name),
                                                        }}
                                                    >
                                                        {/* {detail.name} */}
                                                    </Box>

                                                    {Object.values(detail.values).map(sign => (
                                                        <StyledBox
                                                        padding={'30px 15px'}
                                                            h="100%"
                                                            display={'flex'}
                                                            alignItems={{
                                                                base: 'flex-start',
                                                                lg: 'center',
                                                            }}
                                                            justifyContent={{
                                                                base: 'flex-start',
                                                                lg: 'center',
                                                            }}
                                                            color={'#171717'}
                                                            fontSize={'xs'}
                                                            fontWeight={'normal'}
                                                            lineHeight={'150%'}
                                                        >
                                                            {sign ? (
                                                                <CheckIcon color={'#1AAC7A'} fontSize={'20px'} />
                                                            ) : (
                                                                <Text
                                                                    color={'#C8C8C8'}
                                                                    fontSize={'35px'}
                                                                >
                                                                    -
                                                                </Text>
                                                            )}
                                                        </StyledBox>
                                                    ))}
                                                </Grid>
                                            );
                                        })}
                                    </AccordionPanel>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    );
};
